/**
 * Returns the extension of given filename.
 *
 */
// eslint-disable-next-line no-bitwise
export const getFileExtension = (filename: string) => filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);

export default getFileExtension;
